import React from 'react';
import PropTypes from 'prop-types';

import { LocaleService } from '@sm360/widget-commons-core-services';

import 'deposit/components/DepositState/DepositState.scss';

const DepositState = ({ depositAmount, emailAdress }) => {
    return (
        <div className="deposit-state--wrapper">
            <div className="deposit-state--icon">
                <icon className="icon-Crochet" />
            </div>
            <div className="deposit-state--content">
                <p className="deposit-state--title sr-text is-bold">{LocaleService.t('DEPOSIT.STATE.CONGRATS')}</p>
                <p className="deposit-state--subtitle sr-text is-bold">
                    {LocaleService.t('DEPOSIT.STATE.TITLE', {
                        amount: depositAmount,
                    })}
                </p>
                <p className="deposit-state--content-text">
                    {LocaleService.t('DEPOSIT.STATE.CONTENT', {
                        email: emailAdress,
                    })}
                </p>
            </div>
        </div>
    );
};

DepositState.defaultProps = {
    depositAmount: 500,
};

DepositState.propTypes = {
    depositAmount: PropTypes.number,
    emailAdress: PropTypes.string.isRequired,
};

DepositState.displayName = 'DepositState';

export default DepositState;



// WEBPACK FOOTER //
// ./src/components/DepositState/DepositState.jsx